import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import App from './App';
import { installGlobalErrorHandlers } from './telemetry';
import './index.css';

installGlobalErrorHandlers();

const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error('Flowium root element is missing');
}

createRoot(rootElement).render(
    <StrictMode>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </StrictMode>,
);
